var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1,
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.923 2.14L2.34 5.415a.567.567 0 00.238 1.02l.09.008h12a2.1 2.1 0 012.095 1.95l.005.15v1.899h1.133v-1.9c0-.714-.236-1.404-.666-1.965l-.134-.165-.146-.156a3.233 3.233 0 00-2.073-.94l-.214-.007H4.747l-.058-.181L7.58 3.062l-.657-.922z",
    stroke: "#191C26",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.235 9.309H2.101v1.9c0 .715.237 1.405.667 1.966l.135.165.146.156a3.233 3.233 0 002.072.94l.214.007h9.92l.058.181-2.892 2.065.657.922 4.586-3.274a.567.567 0 00.237-.456l-.006-.089-.02-.089a.567.567 0 00-.45-.386l-.09-.008h-12a2.1 2.1 0 01-2.095-1.95l-.005-.15v-1.9z",
    stroke: "#3B65EE",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/assets/exchange.94cf0a77.svg";
export { ForwardRef as ReactComponent };